'use strict';

import Loading from '../components/Loading';
import FormAgreement from "../components/FormAgreement";

const FormInput =  React.lazy(() => import( /* webpackChunkName: "FormInput" */ '../components/FormInput'));
const PhoneInput =  React.lazy(() => import( /* webpackChunkName: "PhoneInput" */ '../components/PhoneInput'));

class B2bContainer extends React.Component {
    constructor(props) {
        super(props);

        const isExtended = lang === 'en'

        this.initialState = {
            surname: '',
            firstname: '',
            company: '',
            web: '',
            email: '',
            phone: '',
            phoneCode: '',
            regNumber: '',
            vatNumber: '',
            address: '',
            agreeCb: false,
        }

        this.state = {
            isExtended,
            isFetching: false,
            isSent: false,
            errors: {},
            ...this.initialState,
        }

        this.handleSend = this.handleSend.bind(this)
    }

    handleSend() {
        const {surname, firstname, company, web, email, phone, phoneCode, regNumber, vatNumber, address, agreeCb, isExtended, isFetching} = this.state;
        if(isFetching || !agreeCb) return;
        this.setState({isFetching: true});
        articleAction.sendB2bRequest({surname, firstname, company, web, email, phone, phoneCode, regNumber, vatNumber, address, isExtended}).then(response => {
                    this.setState({
                        isFetching: false,
                        errors: {},
                        ...response,
                        ...(response.isSent ? this.initialState : {}),
                    });
                });
    }

    render() {
        const {surname, firstname, company, web, email, phone, phoneCode, errors, regNumber, vatNumber, address, agreeCb, isSent, isExtended, isFetching} = this.state;

        return <div className="b2b-form">
            <div className="b2b-form__row">
                {!isExtended && <div className="b2b-form__col">
                    <React.Suspense>
                        <FormInput
                            className={'profile-input'}
                            label={__('reg.lastname')}
                            value={surname}
                            error={errors.surname}
                            onChange={surname => this.setState({surname})}
                        />
                    </React.Suspense>
                </div>}
                <div className="b2b-form__col">
                    <React.Suspense>
                        <FormInput
                            className={'profile-input'}
                            label={__('hotels.form.name')}
                            value={firstname}
                            error={errors.firstname}
                            onChange={firstname => this.setState({firstname})}
                        />
                    </React.Suspense>
                </div>
                {isExtended && <div className="b2b-form__col">
                    <React.Suspense>
                        <FormInput
                            className={'profile-input'}
                            label={__('reg.lastname')}
                            value={surname}
                            error={errors.surname}
                            onChange={surname => this.setState({surname})}
                        />
                    </React.Suspense> 
                </div>}
            </div>
            <div className="b2b-form__row">
                <div className="b2b-form__col">
                    <React.Suspense>
                        <FormInput
                            className={'profile-input'}
                            label={__('reg.company')}
                            value={company}
                            error={errors.company}
                            onChange={company => this.setState({company})}
                        />
                    </React.Suspense>
                </div>
                <div className="b2b-form__col">
                    <React.Suspense>
                        <FormInput
                            className={'profile-input'}
                            label={__('reg.web')}
                            value={web}
                            error={errors.web}
                            onChange={web => this.setState({web})}
                        />
                    </React.Suspense>
                </div>
            </div>
            <div className="b2b-form__row">
                <div className="b2b-form__col">
                    <React.Suspense>
                        <FormInput
                            className={'profile-input'}
                            label={__('reg.email')}
                            value={email}
                            error={errors.email}
                            onChange={email => this.setState({email})}
                        />
                    </React.Suspense>
                </div>
                <div className="b2b-form__col">
                    <React.Suspense>
                        <PhoneInput
                            className={'profile-input'}
                            label={__('hotels.form.phone')}
                            value={phone}
                            phoneCode={phoneCode}
                            error={errors.phone}
                            onChange={phone => this.setState({phone})}
                            onCodeChange={phoneCode => this.setState({phoneCode})}
                        />
                    </React.Suspense>
                </div>
            </div>

            {isExtended && <div>
                <div className="b2b-form__row">
                    <div className="b2b-form__col">
                        <React.Suspense>
                            <FormInput
                                className={'profile-input'}
                                label={'Company registration number'}
                                value={regNumber}
                                error={errors.regNumber}
                                onChange={regNumber => this.setState({regNumber})}
                            />
                        </React.Suspense>
                    </div>
                    <div className="b2b-form__col">
                        <React.Suspense>
                            <FormInput
                                className={'profile-input'}
                                label={'VAT number'}
                                value={vatNumber}
                                error={errors.vatNumber}
                                onChange={vatNumber => this.setState({vatNumber})}
                            />
                        </React.Suspense>
                    </div>
                </div>
                <div className="b2b-form__row">
                    <div className="b2b-form__col__full">
                        <React.Suspense>
                            <FormInput
                                autoHeight={true}
                                type={'textarea'}
                                className={'profile-input'}
                                label={'Full Address'}
                                value={address}
                                error={errors.address}
                                onChange={address => this.setState({address})}
                            />
                        </React.Suspense>
                    </div>
                </div>
            </div>}

            <div className="b2b-form__checkbox">
                <div className="checkbox">
                    <React.Suspense>
                        <FormAgreement
                            tag={'div'}
                            showCheckboxMedia={false}
                            agreeConditionsValue={agreeCb}
                            onAgreeConditionsChange={agreeCb => this.setState({agreeCb})}
                        />
                    </React.Suspense>

                </div>
            </div>
            <div className="b2b-form__btn">
                {!isSent && <button className={clsx('button button-base', {disabled: !agreeCb})} onClick={this.handleSend}>
                    {__('b2b.sendRequest')}
                </button>}
                {isSent && <button className="button">
                    {__('b2b.sent')}
                </button>}
            </div>
            <Loading active={isFetching}/>
        </div>
    }
}

const domContainer = document.querySelector('#reactB2bContainer');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(B2bContainer));
